<template>
  <div class="yh-page">
    <el-card>
      <el-row slot="header" type="flex" justify="start" align="middle" class="p-3" :gutter="10">
        <el-col :span="10">
          <el-input placeholder="输入账单文件名称进行搜索..." v-model.trim="query.search"
                    @keyup.enter.native="handleSearch">
            <el-button slot="append" icon="el-icon-search" :loading="searching" @click="handleSearch">搜索</el-button>
          </el-input>
        </el-col>
        <el-col :span="14">
          <span>
            <template>
              <el-select v-model="branch_office_id" placeholder="请选择所属分公司" @change="handleSelected">
                <el-option
                  v-for="item in branch_office_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </template>
          </span>
          &nbsp;
          <!-- <span>
            <router-link :to="{name: 'createBillingFile', query:{company: company}}" v-show="showAdd">
              <el-button type="primary" size="small" icon="el-icon-plus">新增</el-button>
            </router-link>
          </span>
          &nbsp;  -->
          <span>
            <el-button v-if="isShowImport && showImport" type="primary" size="small"
              icon="el-icon-upload2" @click="handleBillingFileImport">导入
            </el-button>
          </span>
          &nbsp;
          <span>
            <router-link :to="{name: 'billingFileManagement'}" >
              <el-button type="primary" size="small" icon="el-icon-back">返回</el-button>
            </router-link>
          </span>

        </el-col>
      </el-row>

      <!-- 账单文件列表 -->
      <el-table :key="0" :data="list" stripe v-loading="loading" :element-loading-text="loadingText"
                fit highlight-current-row class="w-100">
        <!-- 操作 -->
        <el-table-column align="left" label="操作" width="150px">
          <template slot-scope="scope">
            <el-tooltip effect="light" placement="top-start" content="编辑">
              <el-button v-if="showEdit" type="text"
                @click="handleUpdate(scope.row.id)" >
                <i class="el-icon-edit"></i>
              </el-button>
            </el-tooltip>

            <el-tooltip effect="light" placement="top-start" content="查看详单">
              <el-button v-if="showView" type="text"
                @click="handleViewRecords(scope.row.id, scope.row.billing_model, scope.row.invoice_type)" >
                <i class="el-icon-document"></i>
              </el-button>
            </el-tooltip>

            <el-tooltip effect="light" placement="top-start" content="下载账单文件">
              <el-button v-if="showExport" type="text"
                @click="handleDownload(scope.row.file, scope.row.original_filename)" >
                <i class="el-icon-download"></i>
              </el-button>
            </el-tooltip>

            <el-tooltip effect="light" placement="top-start" content="删除">
              <el-button v-if="showDelete && scope.row.is_reconciled !== 1" type="text"
                @click="handleDelete(scope.row.id)" >
                <i class="el-icon-delete"></i>
              </el-button>
            </el-tooltip>

            <el-tooltip effect="light" placement="top-start" content="对账">
              <el-button v-if="showRecocile && scope.row.is_reconciled !== 1" type="text"
                @click="handleReconciliation(scope.row.id)" >
                <i class="el-icon-circle-check"></i>
              </el-button>
            </el-tooltip>

            <el-tooltip effect="light" placement="top-start" content="寄送信息">
              <el-button v-if="showRecocile && scope.row.is_invoiced === 1" type="text"
                @click="open(scope.row)" >
                <i class="el-icon-s-promotion"></i>
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- 状态 -->
        <el-table-column align="left" label="状态">
          <template slot-scope="scope">
            <span class="badge mr-1" :class="getStatusBadge(scope.row.is_reconciled)">
            {{ scope.row.is_reconciled| parsereconciliationstatus }}
            </span>
            <span class="badge mr-1" :class="getStatusBadge(scope.row.is_invoiced)">
            {{ scope.row.is_invoiced| parseinvoicedstatus }}
            </span>
            <span class="badge mr-1" :class="Object.getOwnPropertyNames(scope.row.deliver_info).length > 1? 'badge-success' : 'badge-warning'" >
            {{ scope.row | parsedeliverstatus }}
            </span>
            <span class="badge mr-1" :class="getStatusBadge(scope.row.is_collected)">
            {{ scope.row.is_collected| parsepaidstatus }}
            </span>
          </template>
        </el-table-column>

        <!-- id -->
        <el-table-column align="left" label="id" width="50px">
          <template slot-scope="scope">
            <span v-if="showView" class="text-link"
              @click="handleViewRecords(scope.row.id, scope.row.company_code, scope.row.invoice_type)">{{scope.row.id}}</span>
          </template>
        </el-table-column>

        <!-- title -->
        <el-table-column align="left" label="文件名称">
          <template slot-scope="scope">
            <span  v-if="showView" class="text-link"
              @click="handleViewRecords(scope.row.id, scope.row.company_code, scope.row.invoice_type)">{{ scope.row.title }}</span>
          </template>
        </el-table-column>

        <!-- 原文件名 -->
        <el-table-column align="left" label="原文件名">
          <template slot-scope="scope">
            <span  v-if="showView" class="text-link"
              @click="handleViewRecords(scope.row.id, scope.row.company_code, scope.row.invoice_type)">{{ scope.row.original_filename}}</span>
          </template>
        </el-table-column>

        <!-- 保险公司 -->
        <el-table-column align="left" label="保险公司" width="200px">
          <template slot-scope="scope">
            <span>{{ scope.row.company}}</span>
          </template>
        </el-table-column>

        <!-- 保费总额 -->
        <el-table-column align="left" label="保费总额" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.total_premium | parsecurrency}}</span>
          </template>
        </el-table-column>

        <!-- 手续费总额 -->
        <el-table-column align="left" label="手续费总额" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.adjust_commission | parsecurrency}}</span>
          </template>
        </el-table-column>

        <!-- 详单数量 -->
        <el-table-column align="left" label="详单数" width="80px">
          <template slot-scope="scope">
            <span>{{ scope.row.total_details }}</span>
          </template>
        </el-table-column>

        <!-- 开始时间 -->
        <el-table-column align="left" label="开始时间" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.start_time | parseTime('{y}-{m}-{d}') }}</span>
          </template>
        </el-table-column>

        <!-- 结束时间 -->
        <el-table-column align="left" label="结束时间" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.end_time | parseTime('{y}-{m}-{d}') }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="备注">
          <template slot-scope="scope">
            <span>{{ scope.row.remark}}</span>
          </template>
        </el-table-column>

      </el-table>
    </el-card>

    <pagination ref="pagination" :size.sync="query.limit" :offset.sync="query.offset" :total="total" @updateList="getList"></pagination>
    <billing-file-import-dialog
      :company="selected_company_code"
      :branch-office-id="branch_office_id"
      :branch-office-name="selected_branch_office_name"
      :branch-office-code="selected_branch_office_code"
      :company-name="selected_company_name"
      :company-code="selected_company_code"
      :billing-model="selected_billing_model"
      :invocie-type="invoice_type"
      ref="billingFileImport"
      v-on:import-finished="handleImportFinished">
    </billing-file-import-dialog>

    <el-dialog title="发票寄送信息" :visible.sync="dialogFormVisible">
      <el-form ref="deliverForm" :model="deliver_form" :rules="rules">
        <el-form-item label="寄送日期" label-width="120px" prop="date">
          <el-date-picker
            v-model="deliver_form.date"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="物流公司" label-width="120px" prop="company">
          <el-select v-model="deliver_form.company" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号" label-width="120px" prop="number">
          <el-input v-model="deliver_form.number" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="收件人名称" label-width="120px" prop="receiver">
          <el-input v-model="deliver_form.receiver" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="收件地址" label-width="120px" prop="address">
          <el-input v-model="deliver_form.address" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetDeliverForm">取 消</el-button>
        <el-button type="primary" @click="handleDeliverForm">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import {fetchBillingFileListByBranchOfficeCode, deleteBillingFile} from '@/api/billing'
  import { fetchSettingCompanyBranchOfficeOptionsByCompanyCode } from '@/api/billing'
  import {downloadFile} from "@/api/upload";
  import { updateDeliverInfo } from '@/api/billing'
  import Pagination from '@/components/Pagination'
  import { parseTime } from '@/utils'
  import {formatCurrency } from '@/utils/misc'
  import { EventBus } from "@/utils/event-bus"
  import BillingFileImportDialog from './billing-file-import'

  export default {
    name: "billing-file-list",
    components: {
      BillingFileImportDialog,
      Pagination
    },

    filters: {
      parsecurrency: function(value){
        let v = parseFloat(value).toFixed(4)
        return formatCurrency(v, 2)
      },
      parsereconciliationstatus: function(value) {
        let result
        switch(parseInt(value)){
          case -1:
            result = "错误"
            break
          case 0:
            result = "未对账"
            break
          case 1:
            result = "已对账"
            break
          case 2:
            result = "对账失败"
            break
          default:
            result = "未知"
        }
        return result
      },
      parseinvoicedstatus: function(value) {
        let result
        switch(parseInt(value)){
          case -1:
            result = "错误"
            break
          case 0:
            result = "未开发票"
            break
          case 1:
            result = "已开发票"
            break
          case 2:
            result = "开票失败"
            break
          default:
            result = "未知"
        }
        return result
      },
      parsedeliverstatus: function(data) {
        let result
        if (Object.getOwnPropertyNames(data.deliver_info).length == 1 && data.is_collected == 0) {
          result = "未寄送"
        }
        else if (Object.getOwnPropertyNames(data.deliver_info).length > 1) {
          result = "已寄送"
        }
        else {
          result = "未知"
        }
        return result
      },
      parsepaidstatus: function(value) {
        let result
        switch(parseInt(value)){
          case -1:
            result = "错误"
            break
          case 0:
            result = "未收款"
            break
          case 1:
            result = "已收款"
            break
          case 2:
            result = "收款失败"
            break
          default:
            result = "未知"
        }
        return result
      }
    },

    data() {
      return {
        showAdd: false,
        showEdit: false,
        showDelete: false,
        showImport: false,
        showExport: false,
        showView: false,
        showRecocile: false,
        isShowImport: false,

        selected_company_name: '',
        selected_company_code: '',
        selected_branch_office_name: '',
        selected_branch_office_code: '',
        selected_billing_model: '',
        invoice_type: 0,

        searching: false,
        loading: false,
        loadingText: '正在加载数据，请稍等...',
        query: {
          search: '',
          offset: 0,
          limit: 20
        },
        total: 0,
        list: [],

        branch_office_options: [],
        branch_offices: [],
        branch_office_id: null,
        branch_office_name: '',
        branch_office_code: '',
        company_name: '',
        company_code: '',

        billing_file_id: 0,
        dialogFormVisible: false,
        deliver_form: {
          date: new Date(),
          company: '顺丰',
          number: null,
          receiver: null,
          address: null
        },
        options:[
          {value: '顺丰'},
          {value: 'EMS'},
          {value: '圆通'},
          {value: '申通'},
          {value: '中通'},
          {value: '其它'}
        ],
        rules: {
          number: [
            { required: true, message: '请输入物流单号', trigger: 'blur' },
          ],
          company: [
            { required: true, message: '请选择物流公司', trigger: 'blur' },
          ],
          date: [
            { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
          ],
        }
      }
    },

    methods: {
      loadData(company_code) {
        fetchSettingCompanyBranchOfficeOptionsByCompanyCode(this.query, company_code)
          .then(resp => {
            if ('forEach' in resp){
              resp.forEach((item, index)=>{
                this.branch_office_options.push({
                  value: item.id,
                  label: item.branch_office_name
                })
                this.branch_offices.push({
                  branch_office_id: item.id,
                  branch_office_name: item.branch_office_name,
                  branch_office_code: item.branch_office_code,
                  company_name: item.company_name,
                  company_code: item.company_code,
                  billing_model: item.billing_model,
                })
                if (index === 0) {
                  this.branch_office_id = item.id
                  this.selected_company_name = item.company_name
                  this.selected_company_code = item.company_code
                  this.selected_branch_office_name = item.branch_office_name
                  this.selected_branch_office_code = item.branch_office_code
                  this.selected_billing_model = item.billing_model
                  if (this.invoice_type === 1) {
                    this.selected_billing_model = 'yihe'
                  }
                }
              })
              this.getListByBranchOffice(this.selected_branch_office_code)
            } else {
              this.$message.error('获取公司信息失败，请与管理员联系')
              return
            }
          })
          .catch(error => {
            this.$error_message(error)
          })
      },
      getList(){
        this.getListByBranchOffice(this.selected_branch_office_code)
      },
      getListByBranchOffice(branch_office_code) {
        this.loading = true
        fetchBillingFileListByBranchOfficeCode(this.query, branch_office_code, this.invoice_type)
          .then(res => {
            this.list = res.results
            this.total = res.count
            this.loading = false
          })
          .catch(error => {
            this.loading = false
            this.$error_message(error)
          })
      },
      handleSelected(){
        let search_id = this.branch_office_id
        let found = this.branch_offices.find(function(item){
          return item.branch_office_id === search_id
        })

        if (found === undefined || found === null){
          this.$message.error('选择公司出错')
        }

        this.branch_office_name = found.branch_office_name
        this.branch_office_code = found.branch_office_code
        this.company_name = found.company_name
        this.company_code = found.company_code

        this.branch_office_id = found.branch_office_id
        this.selected_company_name = found.company_name
        this.selected_company_code = found.company_code
        this.selected_branch_office_name = found.branch_office_name
        this.selected_branch_office_code = found.branch_office_code
        this.selected_billing_model = found.billing_model
        if (this.invoice_type === 1) {
          this.selected_billing_model = 'yihe'
        }
        this.getListByBranchOffice(this.selected_branch_office_code)
      },
      handleSearch() {
        // this.getListByBranchOffice(this.selected_branch_office_code)
        this.$refs.pagination.backNumOne()
      },
      handleBillingFileImport() {
        if (this.branch_office_id === '' ||
            this.branch_office_id === undefined ||
            this.branch_office_id === null) {
            this.$message.error('请选择所属公司')
            return
        }
        this.$refs.billingFileImport.handleBillingFileImport()
      },
      handleImportFinished(){
        setTimeout(() => {
          this.handleSearch()
        }, 2000)
      },
      handleUpdate(id) {
        this.$router.push({name: 'updateBillingFile', query: {company: this.selected_billing_model, fileId: id}})
      },
      handleViewRecords(id, company_code, invoice_type) {
        this.$router.push({name: 'billingRecordList', query: {company: company_code, fileId: id, invoice_type:invoice_type}})
      },
      handleDownload(file_id, original_filename) {
        downloadFile(file_id)
          .then(res => {
            let link = document.createElement("a");
            link.style.display = "none";

            let blob = new Blob([res], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
            link.href = URL.createObjectURL(blob);

            link.download = original_filename;
            // link.download = res.headers['content-disposition'].match(/fushun(\S*)xls/)[0]
            document.body.appendChild(link);

            link.click();
            URL.revokeObjectURL(blob);
            document.body.removeChild(link);

            // this.downloadURL = url
            // this.filename = file.name
            // this.$refs.download.click()
            // document.body.appendChild(link)
          })
          .catch(error => {
            this.$error_message(error);
          });
      },
      handleDelete(id) {
        deleteBillingFile(this.selected_billing_model, id)
          .then(() =>{
            this.$message.success('账单文件删除成功!')
            this.getListByBranchOffice(this.selected_branch_office_code)
          })
          .catch(error => {
            this.$error_message(error)
          })
      },
      handleReconciliation(id) {
        this.$router.push({name: 'billingReconciliation', query: {billing_model: this.selected_billing_model, fileId: id}})
      },
      isValidCompany(company_code) {
        const validCompanyCodes = [
          'ping_an',
          'zi_jin',
          'yong_cheng',
          'yong_an',
          'ren_bao',
          'tai_bao',
          'da_di',
          'dong_hai',
          'guo_ren',
          'hua_an',
          'zhong_yi_cai',
          'da_jia',
          'tian_an',
          'hua_tai',
          'yihe',
          'zhong_lian_cai',
        ]
        if (validCompanyCodes.indexOf(company_code) > -1) {
          return true
        }
        return  false
      },
      getStatusBadge(value) {
        let badge = 'badge-secondary'
        switch (parseInt(value)) {
          case -1:
            badge = 'badge-danger'
            break
          case 0:
            // badge = 'badge-info'
            badge = 'badge-warning'
            break
          case 1:
            badge = 'badge-success'
            break
          case 2:
            badge = 'badge-warning'
            break
          case 3:
            badge = 'badge-dark'
            break
          default:
            badge = 'badge-secondary'
        }
        return badge
      },
      open(data) {
        this.dialogFormVisible = true
        this.billing_file_id = data.id

        this.deliver_form.date = new Date(data.deliver_info.date).getTime()
        this.deliver_form.company = data.deliver_info.company
        this.deliver_form.number = data.deliver_info.number
        this.deliver_form.address = data.deliver_info.address
        this.deliver_form.receiver = data.deliver_info.receiver
      },
      resetDeliverForm() {
        this.$refs['deliverForm'].resetFields();
        this.dialogFormVisible = false
      },
      handleDeliverForm() {
        this.$refs['deliverForm'].validate((valid) => {
          if (valid) {
            updateDeliverInfo(this.deliver_form, this.billing_file_id)
            .then(() => {
              this.$nextTick(() => {
                this.$message({
                  type: 'success',
                  message: '提交寄送信息成功!'
                });
              setTimeout(() => {
                this.getList()
              }, 1000)
              })
              this.resetDeliverForm()
              this.dialogFormVisible = false
            })
            .catch(error => {
              this.$message.error(error)
            })
          }
          else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },

    created() {
      // 入参检查
      if (this.$route.query.company_code === undefined){
        this.$router.push('/404')
      }
      this.selected_company_code = this.$route.query.company_code
      console.log(this.$route.query.company_code)
      if (this.selected_company_code === 'yihe') {
        this.invoice_type = 1
      }

      // 权限检查
      if (!this.$perm(["billing.list_billing_file"])) {
        this.$router.push('/401')
      }

      if (this.$perm(["billing.create_billing_file"])) {
        this.showAdd = true
      }

      if (this.$perm(["billing.update_billing_file"])) {
        this.showEdit = true
      }

      if (this.$perm(["billing.delete_billing_file"])) {
        this.showDelete = true
      }

      if (this.$perm(["billing.view_billing_file"])) {
        this.showView = true
      }

      if (this.$perm(["billing.import_billing_file"])) {
        this.showImport = true
      }

      if (this.$perm(["billing.export_billing_file"])) {
        this.showExport = true
      }

      if (this.$perm(["billing.reconcile_billing_file"])) {
        this.showRecocile = true
      }

      if (this.isValidCompany(this.selected_company_code)) {
        this.isShowImport = true
      }
      this.loadData(this.selected_company_code)
    }
  }
</script>
